import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import gsap from 'gsap';

/** Wraps route content; fades/slides in on every navigation for a smooth page transition. */
export function usePageTransition() {
  const ref = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    gsap.fromTo(
      node,
      { opacity: 0, y: 12 },
      { opacity: 1, y: 0, duration: 0.35, ease: 'power2.out' }
    );
  }, [location.pathname]);

  return ref;
}
